const API_URL = process.env.REACT_APP_API_URL
const API_TOKEN = process.env.REACT_APP_API_TOKEN


module.exports = {
    host: API_URL,
    apiToken: API_TOKEN,
    ga: process.env.REACT_APP_GAID
}